import { SelectedContentReference, TransactionApi } from 'apis/TransactionApi';

// A single AddContentToTransaction request must not carry too many deliverables. When any list
// exceeds this threshold the payload is split into batches of CHUNK_SIZE sent one after another.
const CHUNK_THRESHOLD = 100;
const CHUNK_SIZE = 20;

export const chunkArray = <T, >(array: T[], chunkSize: number): T[][] => {

    const result: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {

        result.push(array.slice(i, i + chunkSize));

    }
    return result;

};

// Adds pending tests/books/courses to a transaction, chunking large payloads so a single request
// never carries more than CHUNK_SIZE deliverables of a given type. Rejects if any request fails.
export const addContentToTransactionChunked = async (
    transactionId: number,
    pendingTests: SelectedContentReference[] = [],
    pendingBooks: SelectedContentReference[] = [],
    pendingCourses: SelectedContentReference[] = []
): Promise<void> => {

    const shouldChunk = pendingTests.length > CHUNK_THRESHOLD
        || pendingBooks.length > CHUNK_THRESHOLD
        || pendingCourses.length > CHUNK_THRESHOLD;

    if (!shouldChunk) {

        await TransactionApi.AddContentToTransaction(transactionId, pendingTests, pendingBooks, pendingCourses);
        return;

    }

    const chunkedTests = chunkArray(pendingTests, CHUNK_SIZE);
    const chunkedBooks = chunkArray(pendingBooks, CHUNK_SIZE);
    const chunkedCourses = chunkArray(pendingCourses, CHUNK_SIZE);
    const batches = Math.max(chunkedTests.length, chunkedBooks.length, chunkedCourses.length);

    for (let index = 0; index < batches; index++) {

        await TransactionApi.AddContentToTransaction(
            transactionId,
            chunkedTests[index] ?? [],
            chunkedBooks[index] ?? [],
            chunkedCourses[index] ?? []
        );

    }

};
